import React from 'react'
import { Link } from 'react-router-dom'

function Blog() {
  return (
    <div>
    <div className="subheader normal-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12 text-left">
            <h1 className="text-custom-white">Blog</h1>
            <ul className="custom-flex">
              <li className="fw-500"> <Link to="/" className="text-custom-white">Home</Link> </li>
              <li className="active fw-500"> Blog </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- End Subheader --> 
    <!-- Start Blog --> */}
    <section className="section-padding our_articles bg-light-white">
      <div className="container">
        <div className="row">
          <h6 className="d-none">1</h6>
          <article className="col-lg-4 col-md-6 post mb-xl-30">
            <div className="post-wrapper bx-wrapper">
              <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-1.jpg" className="full-width" alt="img"/> </Link>
              
              </div>
              <div className="blog-meta padding-20 bg-custom-white p-relative">
                <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                <div className="post-heading">
                  <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Selecting The Proper Bicycle </Link> </h2>
                  <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                </div>
              </div>
              <div className="post-footer">
              
                <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
            </div>
          </article>
          
          <article className="col-lg-4 col-md-6 post mb-xl-30">
            <div className="post-wrapper bx-wrapper">
              <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-2.jpg" className="full-width" alt="img"/> </Link>
              
              </div>
              <div className="blog-meta padding-20 bg-custom-white p-relative">
                <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 30 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 20 Likes </Link> </div>
                <div className="post-heading">
                  <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Michael Valenti Cycling </Link> </h2>
                  <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                </div>
              </div>
              <div className="post-footer">
                <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
            </div>
          </article>
         
          <article className="col-lg-4 col-md-6 post mb-xl-30">
            <div className="post-wrapper bx-wrapper">
              <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-3.jpg" className="full-width" alt="img"/> </Link>
              
              </div>
              <div className="blog-meta padding-20 bg-custom-white p-relative">
                <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 10 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 26 Likes </Link> </div>
                <div className="post-heading">
                  <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Tie—Bike Snob NYC</Link> </h2>
                  <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                </div>
              </div>
              <div className="post-footer">
                <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
            </div>
          </article>
          
          <article className="col-lg-4 col-md-6 post mb-xl-30">
            <div className="post-wrapper bx-wrapper">
              <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-4.jpg" className="full-width" alt="img"/> </Link>
              </div>
              <div className="blog-meta padding-20 bg-custom-white p-relative">
                <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 10 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 26 Likes </Link> </div>
                <div className="post-heading">
                  <h2> <Link to="#" className="text-custom-black fw-600 fs-20"> Bangable Dudes Cycling</Link> </h2>
                  <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                </div>
              </div>
              <div className="post-footer">
                <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
            </div>
          </article>
          
          <article className="col-lg-4 col-md-6 post mb-xl-30">
            <div className="post-wrapper bx-wrapper">
              <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-5.jpg" className="full-width" alt="img"/> </Link>
              
              </div>
              <div className="blog-meta padding-20 bg-custom-white p-relative">
                <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 10 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 26 Likes </Link> </div>
                <div className="post-heading">
                  <h2> <Link to="#" className="text-custom-black fw-600 fs-20"> Red Kite Prayer </Link> </h2>
                  <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                </div>
              </div>
              <div className="post-footer">
                <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
            </div>
          </article>
         
          <article className="col-lg-4 col-md-6 post mb-xl-30">
            <div className="post-wrapper bx-wrapper">
              <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-6.jpg" className="full-width" alt="img"/> </Link>
              
              </div>
              <div className="blog-meta padding-20 bg-custom-white p-relative">
                <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                <div className="post-heading">
                  <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Adventure Journal</Link> </h2>
                  <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                </div>
              </div>
              <div className="post-footer">
              
                <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
            </div>
          </article>
         
          <article className="col-lg-4 col-md-6 post mb-xl-30">
            <div className="post-wrapper bx-wrapper">
              <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-7.jpg" className="full-width" alt="img"/> </Link>
              
              </div>
              <div className="blog-meta padding-20 bg-custom-white p-relative">
                <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 10 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 26 Likes </Link> </div>
                <div className="post-heading">
                  <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Selecting The Proper Bicycle</Link> </h2>
                  <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                </div>
              </div>
              <div className="post-footer">
              
                <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
            </div>
          </article>
        
          <article className="col-lg-4 col-md-6 post mb-sm-30">
            <div className="post-wrapper bx-wrapper">
              <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-8.jpg" className="full-width" alt="img"/> </Link>
              
              </div>
              <div className="blog-meta padding-20 bg-custom-white p-relative">
                <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                <div className="post-heading">
                  <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Tie—Bike Snob NYC</Link> </h2>
                  <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                </div>
              </div>
              <div className="post-footer">
              
                <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
            </div>
          </article>
         
          <article className="col-lg-4 col-md-6 post">
            <div className="post-wrapper bx-wrapper">
              <div className="post-img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-3.jpg" className="full-width" alt="img"/> </Link>
              
              </div>
              <div className="blog-meta padding-20 bg-custom-white p-relative">
                <div className="post-meta mb-xl-20"> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 3 Comments </Link> <Link to="#" className="text-light-dark mr-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 2 Likes </Link> </div>
                <div className="post-heading">
                  <h2> <Link to="#" className="text-custom-black fw-600 fs-20">Bangable Dudes Cycling</Link> </h2>
                  <p className="text-light-dark no-margin">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's...</p>
                </div>
              </div>
              <div className="post-footer">
              
                <Link to="/blog-details" className="btn-first btn-submit fs-14 fs-600">Read More</Link> </div>
            </div>
          </article>
        </div>
        <div className="row">
          <div className="col-12">
            <nav className="section-padding-top">
              <ul className="pagination justify-content-center">
                <li className="page-item"><Link className="page-link" to="#">Previous</Link></li>
                <li className="page-item"><Link className="page-link" to="#">1</Link></li>
                <li className="page-item active"><Link className="page-link" to="#">2</Link></li>
                <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                <li className="page-item"><Link className="page-link" to="#">Next</Link></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default Blog